import { Responsavel } from "./responsavel.model";
import { Capacitadora } from "./capacitadora.model";

export class CapacitadoraResponsavel {
    public id_responsavel: number;
    public id_capacitadora: number;

    public capacitadora:Capacitadora;
    public responsavel: Responsavel;


}


// WEBPACK FOOTER //
// ./src/app/entity/capacitadora-responsavel.model.ts